import { RouteObject } from 'react-router-dom';

const adminRoutes: RouteObject[] = [
  {
    path: '/admin',
    lazy: async () => {
      const { AdminLayout } = await import('@/layouts/DashboardLayout');
      return { Component: AdminLayout };
    },
    children: [
      {
        index: true,
        lazy: () => import('@/pages/admin/home')
      },
      {
        path: 'settings',
        lazy: () => import('@/pages/admin/settings')
      },
      {
        path: 'accounts',
        lazy: () => import('@/pages/admin/accounts')
      },
      {
        path: 'accounts/create',
        lazy: () => import('@/pages/admin/accounts-create')
      },
      {
        path: 'accounts/:id',
        lazy: () => import('@/pages/admin/accounts-details')
      },
      {
        path: 'medications',
        lazy: () => import('@/pages/admin/medications')
      },
      {
        path: 'medications/:id',
        lazy: () => import('@/pages/admin/medications-details')
      },
      {
        path: 'users',
        lazy: () => import('@/pages/admin/users')
      },
      {
        path: 'resource-library',
        lazy: () => import('@/pages/admin/resource-library')
      }
    ]
  }
];

export default adminRoutes;
